export default function Features() {
  return (
    <div id="features" className="features-section">
      <div className="features-bg">
        <div className="features-grid-bg"></div>
      </div>
      <div className="container">
        <div className="section-header">
          <div className="features-label">AVANTAGES</div>
          <h2>Pourquoi Jean-Louis ?</h2>
          <p className="section-description">La seule plateforme qui unifie prospection, enrichissement et outreach</p>
        </div>

        <div className="features-comparison">
          <div className="comparison-column problem">
            <div className="column-header">
              <div className="column-icon problem-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 12L20 20M20 12L12 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <h3>Sans Jean-Louis</h3>
            </div>
            <ul className="comparison-list">
              {['5+ outils déconnectés', 'Données dispersées et dupliquées', 'Messages génériques et impersonnels', 'Taux de réponse < 5%', 'Configuration complexe (semaines)', 'Coûts cachés et engagement long terme'].map((item, i) => (
                <li key={i}>
                  <span className="bullet"></span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="comparison-divider">
            <svg width="2" height="100%" fill="none">
              <line x1="1" y1="0" x2="1" y2="100%" stroke="var(--color-border)" strokeWidth="2" strokeDasharray="8 8" />
            </svg>
          </div>

          <div className="comparison-column solution">
            <div className="column-header">
              <div className="column-icon solution-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M28 8L12 24L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Avec Jean-Louis</h3>
            </div>
            <ul className="comparison-list">
              {['Plateforme tout-en-un', 'Base unifiée de 50M+ profils', 'IA générative pour personnalisation', 'Taux de réponse jusqu\'à 35%', 'Opérationnel en 5 minutes', 'Tarification transparente et flexible'].map((item, i) => (
                <li key={i}>
                  <span className="bullet"></span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="features-stats">
          {[
            { value: '7x', label: 'Plus de réponses' },
            { value: '80%', label: 'Temps économisé' },
            { value: '95%', label: 'Précision des données' },
            { value: '5min', label: 'Setup complet' },
          ].map((stat, i) => (
            <div key={i} className="stat-item">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
